import React from 'react';
import PropTypes from 'prop-types';
import styles from './BetaBadge.module.css';

const TIP_TEXT = 'This is a new insight. Please share your feedback on how to improve it using the Yes/No buttons below';
export default function BetaBadge({ className = '' }) {
  return (
    <React.Fragment>
      <span className={`${styles.beta} ${className}`} data-tip={TIP_TEXT}>BETA</span>
    </React.Fragment>
  );
}

BetaBadge.propTypes = {
  className: PropTypes.string,
};
